import { render, staticRenderFns } from "./TextDialog.vue?vue&type=template&id=20d3d0dd"
import script from "./TextDialog.vue?vue&type=script&lang=js"
export * from "./TextDialog.vue?vue&type=script&lang=js"
import style0 from "./TextDialog.vue?vue&type=style&index=0&id=20d3d0dd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports